import getEnv from "@utils/getEnv";

export const inDevTestLocal = ["local", "dev"].includes(getEnv().ENV || "");
